import data from './business.json';

/**
 * Real, client-verified business details. Leave a field as an empty string
 * until it is confirmed — every place that shows it (header, footer, contact
 * page, structured data) renders nothing for an empty value rather than a
 * placeholder. `scripts/prerender-meta.mjs` reads the same JSON file.
 */
export type BusinessInfo = {
  name: string;
  url: string;
  description: string;
  /** Display format, e.g. "(555) 123-4567". */
  phone: string;
  email: string;
  /** e.g. "Serving Hamilton County and surrounding areas". */
  serviceArea: string;
  /** e.g. "We reply within one business day." */
  responseTime: string;
};

export const BUSINESS: BusinessInfo = data;

/** `tel:` href from a display-formatted phone number. */
export function telHref(phone: string): string {
  return `tel:${phone.replace(/[^\d+]/g, '')}`;
}
